var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"title":_vm.$t('_.exchange_rates_history')},on:{"close":function($event){return _vm.$emit('close')}}},[_c('exchange-rates-provider',{attrs:{"ignore-history":true}},[_c('exchange-rates-listing')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }